'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emptyFunction = require('react-utils/emptyFunction');

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _PromptablePropInterface = require('UIComponents/decorators/PromptablePropInterface');

var _PromptablePropInterface2 = _interopRequireDefault(_PromptablePropInterface);

var _ActivationErrorModal = require('ui-addon-upgrades/_core/common/components/ActivationErrorModal');

var _ActivationErrorModal2 = _interopRequireDefault(_ActivationErrorModal);

var _ActivationSuccessModal = require('ui-addon-upgrades/_core/common/components/ActivationSuccessModal');

var _ActivationSuccessModal2 = _interopRequireDefault(_ActivationSuccessModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActivationModalContainer = function (_Component) {
  _inherits(ActivationModalContainer, _Component);

  function ActivationModalContainer() {
    _classCallCheck(this, ActivationModalContainer);

    var _this = _possibleConstructorReturn(this, (ActivationModalContainer.__proto__ || Object.getPrototypeOf(ActivationModalContainer)).call(this));

    _this.handleModalClose = _this.handleModalClose.bind(_this);
    return _this;
  }

  _createClass(ActivationModalContainer, [{
    key: 'handleModalClose',
    value: function handleModalClose() {
      var _props = this.props,
          onReject = _props.onReject,
          onSuccess = _props.onSuccess;


      onReject();
      onSuccess();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          hasError = _props2.hasError,
          type = _props2.type;


      if (hasError) {
        return _react2.default.createElement(_ActivationErrorModal2.default, null);
      }

      return _react2.default.createElement(_ActivationSuccessModal2.default, { type: type, onSuccess: this.handleModalClose });
    }
  }]);

  return ActivationModalContainer;
}(_react.Component);

ActivationModalContainer.defaultProps = {
  hasError: false,
  shouldHideSurvey: false,
  onSuccess: _emptyFunction2.default
};

ActivationModalContainer.propTypes = _extends({
  hasError: _react.PropTypes.bool.isRequired,
  type: _react.PropTypes.string.isRequired,
  onSuccess: _react.PropTypes.func
}, _PromptablePropInterface2.default);

exports.default = ActivationModalContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/components/ActivationModalContainer.js
// module id = 652
// module chunks = 3 4